module.exports = {
  path: '/contact',
  title: 'Discuss Your AI Implementation Project | DataBackfill',
  description: 'Discuss an AI agent, RAG or workflow automation project with DataBackfill. Share your workflow, integrations and requirements to define the implementation scope.',
};
